/**
 * Placeholder YouTube URL для `<VideoButton>` на Экране 2.11.1 «Личный кабинет»
 * (CLAUDE.md §16.4 / P-040 — на entry-экранах функций видео-инструкция первым
 * элементом контента). На дочерних экранах ЛК (2.11.2–2.11.4) не дублируется.
 *
 * Реальный URL подставит продакт когда видео-инструкция для Block 11 будет готова.
 */
// TODO(product): replace with real YouTube URL when видео-инструкция для Block 11 ready.
export const CABINET_VIDEO_URL = 'https://www.youtube.com/watch?v=PLACEHOLDER_BLOCK_11';
